import React from "react";
import { Link } from "react-router-dom";
import { Images } from "../../../utils/constant";

const TripTopBar = ({ label }: { label?: string }) => {
  return (
    <header className="trip-topbar">
      <Link to="/" aria-label="Go to home">
        <img
          src={Images.logoIcon}
          alt="DiveBuddies"
          className="trip-topbar-logo"
        />
      </Link>
      <p className="trip-topbar-label">{label || "Trip"}</p>
      <Link to="/" className="trip-close-btn" aria-label="Close trip">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
          <path
            d="M1 1L13 13M13 1L1 13"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </svg>
      </Link>
    </header>
  );
};

export default TripTopBar;
